import React from 'react';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import './Accredited.scss';
import Service from '../../components/Service/Service';
import { useTranslation } from '../../i18n/useTranslation';
import euroarab from '../../assets/Accredited/euroarab.jpeg';
import gig from '../../assets/Accredited/gig.jpeg';
import globemed from '../../assets/Accredited/globemed.jpeg';
import iiab from '../../assets/Accredited/iiab.jpeg';
import mednet from '../../assets/Accredited/mednet.jpeg';
import medconnect from '../../assets/Accredited/medconnect.jpeg';
import medservice from '../../assets/Accredited/medservice.jpeg';
import nethealth from '../../assets/Accredited/nethealth.jpeg';
import solidarity from '../../assets/Accredited/solidarity.jpeg';

const Accredited = () => {
    const { t } = useTranslation();
    
    const AccreditedData = [
        { icon: medconnect, title: 'MEDCONNECT' },
        { icon: nethealth, title: 'NatHealth' },
        { icon: medservice, title: 'Med. Service' },
        { icon: mednet, title: 'Med Net' },
        { icon: gig, title: 'GIG Jordan' },
        { icon: solidarity, title: 'SOLIDARITY' },
        { icon: euroarab, title: 'EURO ARAB' },
        { icon: iiab, title: 'ISLAMIC INTERNATIONAL ARAB BANK' },
        { icon: globemed, title: 'GlobeMed' }
    ];
    
    return (
        <section className='service-section pt-100 pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-sm-6">
                        <SectionTitle title={t('accredited.title')} subTitle={t('accredited.subTitle')}/>
                    </div>
                </div>

                <div className="row">
                    {
                        AccreditedData.map((singleService, index) => (
                            <Service key={index} serviceList={singleService} accredited={true}/>
                        ))
                    }
                </div>
            </div>
        </section>
    );
};

export default Accredited;